export type OptionBoxMeta = {
  questionId: string
  optionIndex: number
}

export const parseOptionBoxId = (boxId: string): OptionBoxMeta | null => {
  const [questionId, kind, idxStr] = boxId.split(",")
  if (!questionId || kind !== "radio") return null
  const optionIndex = Number(idxStr)
  if (!Number.isFinite(optionIndex)) return null
  return { questionId, optionIndex }
}

export const getResponsePairIdFromBoxId = (boxId: string) => boxId.split(",")[0]

export const createOptionBoxId = (questionId: string, optionIndex: number) =>
  `${questionId},radio,${optionIndex}`

const SIGNATURE_BOX_ID_PREFIX = "sig:"

export const createSignatureBoxId = (placementId: string) =>
  `${SIGNATURE_BOX_ID_PREFIX}${placementId}`

export const isSignatureBoxId = (boxId: string) =>
  boxId.startsWith(SIGNATURE_BOX_ID_PREFIX)

export const getSignaturePlacementIdFromBoxId = (boxId: string) =>
  boxId.slice(SIGNATURE_BOX_ID_PREFIX.length)
